import React from "react";
import "./Header.css";
import { ReactComponent as LogoTVA } from "../asset/Logo Julia_widget.svg";
import refresh from "../asset/newRefresh.png";
import { Button, Container } from "react-bootstrap";

const Header = ({ onReset }) => (
  <Container fluid className="p-0">
    <header className="header-web-chat">
      <div className="header-center">
        <LogoTVA className="header-logo" role="img" aria-label="Logo Julia" />
      </div>

      <div className="header-actions">
        <Button
          className="restart"
          variant="restart"
          size="sm"
          onClick={onReset}
          aria-label="Riavvia chat"
        >
          <img className="icon" src={refresh} alt="" />
        </Button>
      </div>
    </header>
  </Container>
);

export default Header;
